export default __webpack_public_path__ + "static/alkemi-about1-199e220bfdf67ff671d3162b6b9500ff.jpg";